import EcommerceProfitCalculator from '@/tools/ecommerceProfitCalculator.vue';
import { mountVueTool } from './shared/mountVueTool';

mountVueTool(EcommerceProfitCalculator, 'ecommerceProfitCalculator');
